import { FC } from "react";
import { useTranslation } from "react-i18next";

export const CardBoardNoData: FC = () => {
  const { t } = useTranslation();
  return <div className="CardBoardNoData">{t("general.NO_ROWS")}</div>;
};
